export interface ErrorCode {
  code: string;
  message: string;
}

/**
 * NOTE: the ErrorCodes message fields should be user friendly error messages.
 */
const ErrorCodes = {
  invalid_respelling: {
    code: 'invalid_respelling',
    message:
      'Failed to save. Ensure Respelling is formatted correctly or try turning it off',
  },
  double_colon_respelling: {
    code: 'double_colon_respelling',
    message:
      'Phonetic Respelling is already on. Remove :: :: format to continue',
  },
  replacement_too_long: {
    code: 'replacement_too_long',
    message: 'Replacement entered is too long',
  },
  word_too_long: {
    code: 'replacement_too_long',
    message: 'Original word entered is too long',
  },
};

export default ErrorCodes;
